export enum AssistantMessageType {
  AI = 'ai',
  Human = 'human',
}

export type AssistantMessage = {
  type: AssistantMessageType;
  content: string;
};

export type AssistantResponse = {
  thread_id: string;
  messages: AssistantMessage[];
};

export type AssistantRequest = {
  workspaceId: string;
  thread_id?: string;
  question: string;
  signal?: AbortSignal;
};

export type GetThreadArgs = {
  thread_id: string;
  workspaceId: string;
  signal?: AbortSignal;
};

export type GetStatusArgs = {
  workspaceId: string;
  signal?: AbortSignal;
};
